import * as React from "react";
const BookletIcon = (props) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.67442 12H4.32558C1.29488 12 0 10.7051 0 7.67442V4.32558C0 1.29488 1.29488 0 4.32558 0H7.11628C7.34512 0 7.53488 0.189767 7.53488 0.418605C7.53488 0.647442 7.34512 0.837209 7.11628 0.837209H4.32558C1.75256 0.837209 0.837209 1.75256 0.837209 4.32558V7.67442C0.837209 10.2474 1.75256 11.1628 4.32558 11.1628H7.67442C10.2474 11.1628 11.1628 10.2474 11.1628 7.67442V4.88372C11.1628 4.65488 11.3526 4.46512 11.5814 4.46512C11.8102 4.46512 12 4.65488 12 4.88372V7.67442C12 10.7051 10.7051 12 7.67442 12Z"
      fill="#4B5155"
    />
    <path
      d="M11.581 5.30236H9.34843C7.43959 5.30236 6.69727 4.56003 6.69727 2.65119V0.418635C6.69727 0.251193 6.79773 0.0949143 6.95401 0.033519C7.11029 -0.0334578 7.28889 0.00561203 7.41168 0.122821L11.8768 4.58794C11.994 4.70515 12.0331 4.88933 11.9661 5.04561C11.8991 5.20189 11.7484 5.30236 11.581 5.30236ZM7.53447 1.42887V2.65119C7.53447 4.09119 7.90843 4.46515 9.34843 4.46515H10.5708L7.53447 1.42887Z"
      fill="#4B5155"
    />
    <path
      d="M6.55846 6.97686H3.20962C2.98078 6.97686 2.79102 6.78709 2.79102 6.55825C2.79102 6.32942 2.98078 6.13965 3.20962 6.13965H6.55846C6.78729 6.13965 6.97706 6.32942 6.97706 6.55825C6.97706 6.78709 6.78729 6.97686 6.55846 6.97686Z"
      fill="#4B5155"
    />
    <path
      d="M5.44218 9.20928H3.20962C2.98078 9.20928 2.79102 9.01951 2.79102 8.79067C2.79102 8.56184 2.98078 8.37207 3.20962 8.37207H5.44218C5.67102 8.37207 5.86078 8.56184 5.86078 8.79067C5.86078 9.01951 5.67102 9.20928 5.44218 9.20928Z"
      fill="#4B5155"
    />
  </svg>
);
export default BookletIcon;
